// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const WIZARD_TWINGRAPH_QUERIES = {
  SET_TWINGRAPH_QUERIES_STATUS: 'SET_TWINGRAPH_QUERIES_STATUS',
  INITIALIZE_GANTT_CHART_TWINGRAPH_QUERIES: 'INITIALIZE_GANTT_CHART_TWINGRAPH_QUERIES',
  INITIALIZE_SELECTED_GISEMENT_TWINGRAPH_QUERIES: 'INITIALIZE_SELECTED_GISEMENT_TWINGRAPH_QUERIES',
  SET_GANTT_QUERIES_RESULTS: 'SET_GANTT_QUERIES_RESULTS',
  SET_NEW_TABLES_MAPPING: 'SET_NEW_TABLES_MAPPING',
  PROCESS_TECHNICAL_POLICY_TWINGRAPH_QUERIES: 'PROCESS_TP_WIZARD_TWINGRAPH_QUERIES_RESULTS',
  UPDATE_TECHNICAL_POLICY: 'UPDATE_TECHNICAL_POLICY',
  DELETE_GISEMENT: 'DELETE_GISEMENT',
  INITIALIZE_AGING_LAWS_TWINGRAPH_QUERIES: 'INITIALIZE_AGING_LAWS_TWINGRAPH_QUERIES_RESULTS',
  PROCESS_AGING_LAWS_TWINGRAPH_QUERIES: 'PROCESS_AGING_LAWS_TWINGRAPH_QUERIES_RESULTS',
  ADD_TECHNICAL_VAR: 'ADD_TECHNICAL_VAR',
  RESET_TECHNICAL_VARS: 'RESET_TECHNICAL_VARS',
  INITIALIZE_DATA_VECTOR_TWINGRAPH_QUERIES: 'INITIALIZE_DATA_VECTOR_TWINGRAPH_QUERIES_RESULTS',
  PROCESS_DATA_VECTOR_TWINGRAPH_QUERIES: 'PROCESS_DATA_VECTOR_TWINGRAPH_QUERIES_RESULTS',
};
